<template>
  <div class="container grading">
    <el-radio-group v-model="section">
      <el-radio-button label="Speaking"></el-radio-button>
      <el-radio-button label="Writing"></el-radio-button>
    </el-radio-group>
    <hr />
    <!-- <div v-html="suggest"></div>
    <div v-html="user_answer[0]"></div> -->
    <div v-show="section === 'Writing'">
      <PageTitle>{{ $t("GradingSamples.TOEFL Writing Grading") }}</PageTitle>
      <el-radio-group v-model="type" class="mt-3">
        <el-radio-button label="Vip"></el-radio-button>
        <el-radio-button label="Simple"></el-radio-button>
      </el-radio-group>
      <div class="report">
        <div class="report-title">
          <div class="title-cont">
            <div class="title">
              {{ $t("GradingSamples.Grading Samples") }}
            </div>
          </div>
        </div>
        <el-alert
          v-if="type === 'Vip'"
          :title="$t('grading.yourScoreAndDetailedComments')"
          type="success"
          :closable="false"
          show-icon
        >
        </el-alert>
        <el-alert
          v-if="type === 'Simple'"
          :title="$t('grading.yourScoreAndComments')"
          type="info"
          :closable="false"
          show-icon
        >
        </el-alert>
        <h5 style="margin:20px 32px">
          Task 1:
          <em
            >Do you agree or disagree with the following statement? Boys and
            girls should attend separate schools. Use specific reasons and
            examples to explain your answer.</em
          >
        </h5>
        <div class="report-body" v-show="type === 'Vip'">
          <Writing
            :score="22"
            :list="vipWriting.list"
            :examInfo="vipWriting.exam_info"
            :commentCategories="commentCategories"
            :hideTitle="true"
            @openWarningSpeaking="getAlert()"
          />
        </div>
        <div class="report-body" v-show="type === 'Simple'">
          <Writing
            :score="22"
            :list="simpleWriting.list"
            :examInfo="simpleWriting.exam_info"
            :commentCategories="commentCategories"
            :hideTitle="true"
            @openWarningSpeaking="getAlert()"
          />
        </div>
      </div>
    </div>
    <div v-show="section === 'Speaking'">
      <PageTitle>TOEFL Speaking: Simple Grading</PageTitle>
      <div class="report">
        <div class="report-title">
          <div class="title-cont">
            <div class="title">
              {{ $t("GradingSamples.Grading Samples") }}
            </div>
          </div>
        </div>
        <div class="report-body">
          <Speaking
            :score="19"
            :list="simpleSpeaking.list"
            :examInfo="simpleSpeaking.exam_info"
            :commentCategories="commentCategoriesSpeaking"
            :hideTitle="true"
            @openWarningSpeaking="getAlert()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./style/reportcard.css";
import PageTitle from "@/components/PageTitle.vue";
import Writing from "./Writing";
import Speaking from "./Speaking";
export default {
  metaInfo() {
    return {
      title: "Grading Samples: Simple Grading vs. VIP Grading - TOEFL Academy"
    };
  },

  components: {
    PageTitle,
    Writing,
    Speaking
  },

  mixins: [],

  props: [],
  data() {
    return {
      user_answer: [
        "Some\tpeople\tmight\tthink\tthat\tattend\tseparate\tschools\tis\tgood\tfor\tstudents,\tothers\tconsider\tthat\t\nstudents\tshould\tattend\tschools\twithout\tdiverse\tof\tgenders.\tFor\tme,\tI\twas\teager\tto\tattend\tto\tgirls’\t\nhigh\tschool.\tBecause\texcellent\tstudents\toften\tchoose\tto\tstudy\tthere\tin\tthe\tTaiwan.\tTherefore,\t\nboys\tand\tgirls\tattending\tseparate\tschools\tbecause\tof\tmany\treason.\n\nFirst,\tstudents\twould\tbe\tmore\tconcentrated\ton\ttheir\tstudies.\tEveryone\tknow\thow\teasy\tto\t\ndistruct.\tAs\tmy\tsister\tWinnie,\tshe\tattended\tto\tTaipei\tFist\tGirls’\thigh\tschool\twhen\tshe\twas\t\nsixteen.\tIn\tthere,\tthey\toften\tstudied\tand\tplayed\ttogether\tall\tthe\ttime.\tDue\tthe\theavy\tworks,\tshe\t\nneed\tto\tstudy\tmore\tharder\tto\tget\thigher\tperformance.\tTherefore,\tstudying\tin\ta\tgirls’\thigh\tschool\t\nis\ta\tbest\tchose\tfor\ther.\tClassmates\twith\tsame\tages\tand\tgander\thelped\ther\tsolve\tmathematic\t\nproblems.\tGo\tto\tlibraries\ton\tweekends\tand\tattended\tto\tcram\tschools.\tSince\tthen,\tWinnie\twere\t\ninfluenced\tby\ther\tfriends\tthat\tshe\tworked\thardly\ton\tevery\tevent\tand\tfinally\tattended\tto\tTaiwan\t\nUniversity,\twhich\tthe\ttop\tone\tuniversity\tin\tthe\tTaiwan.\tAs\ta\tresult,\tstudying\twith\tsame\tgander\t\nschools\tdo\tactually\tmake\tstudents\twork\thardly.\n\nTo\tsum\tup,\tit\tis\tclear\tfor\twell\tdevelopment\tof\tstudents,\tseparate\tschool\tis\trequirement\tfor\t\nmorden\tsociety"
      ],
      suggest:"<h5><strong>TOEFL Writing Rubric Score Level: <span style=\"color:#f39c12\">2/5</span></strong></h5>\n\n<table border=\"1\" cellpadding=\"1\" cellspacing=\"1\" style=\"width:100%\">\n\t<tbody>\n\t\t<tr>\n\t\t\t<td style=\"text-align:center; vertical-align:middle; width:350px\"><strong>An essay at this level may reveal one or more of the following weaknesses:</strong></td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle; width:100px\">\n\t\t\t<p><strong>Score</strong></p>\n\n\t\t\t<p><strong>(1~5)</strong></p>\n\t\t\t</td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle\"><strong>Teacher Commentary</strong></td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>\n\t\t\t<ul>\n\t\t\t\t<li>Addressing the topic and task</li>\n\t\t\t</ul>\n\t\t\t</td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle\"><span style=\"color:#f39c12\"><strong>2</strong></span></td>\n\t\t\t<td><span style=\"color:#f39c12\">Although the task requires you to &ldquo;agree or disagree,&rdquo; you never state whether you agree or disagree. Instead, you seem to make an argument that the statement is true. Arguing in favor of a point-of-view is not the task you are asked to complete. Instead, you should explain why you agree or disagree with a statement</span></td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>\n\t\t\t<ul>\n\t\t\t\t<li>Organization, development, and details</li>\n\t\t\t</ul>\n\t\t\t</td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle\"><span style=\"color:#f39c12\"><strong>2</strong></span></td>\n\t\t\t<td><span style=\"color:#f39c12\">The question prompt asks you to use reasons to explain your answer. There may be reasons in this answer, but they are not clearly marked. Further, the connection between your ideas is not expressed clearly enough. For example, you say that you are &ldquo;eager to attend to girls high school&rdquo; because &ldquo;excellent students study there.&rdquo; However, you don&rsquo;t explain why this is because &ldquo;boys and girls attend separate schools.&rdquo; Aren&rsquo;t there excellent students at mixed schools, too?</span></td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>\n\t\t\t<ul>\n\t\t\t\t<li>Unity, progression, and coherence</li>\n\t\t\t</ul>\n\t\t\t</td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle\"><strong><span style=\"color:#f39c12\">2</span></strong></td>\n\t\t\t<td><span style=\"color:#f39c12\">None of the things that &ldquo;Winnie&rdquo; did are unique to single-gender schools. Thus, your examples seem inappropriate and insufficient.</span></td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>\n\t\t\t<ul>\n\t\t\t\t<li>Language use, word choice, and grammar</li>\n\t\t\t</ul>\n\t\t\t</td>\n\t\t\t<td style=\"text-align:center; vertical-align:middle\"><strong><span style=\"color:#f39c12\">2</span></strong></td>\n\t\t\t<td><span style=\"color:#f39c12\">There are multiple cases of word form errors. It would be useful for you to review some fundamental grammar principles. See my comments to the right of your essay. In addition, There are many sentence structure errors. You might want to work with a teacher to make certain that you understand correct sentence structure. See my comments to the right of your essay.</span></td>\n\t\t</tr>\n\t</tbody>\n</table>\n\n",
      section: "Writing",
      activeName: "vip",
      type: "Vip",
      commentCategories: {
        writing_integrated: [
          {
            id: 4,
            order: 1,
            title: { en: "Reading Content", tw: "閱讀內容", cn: "阅读内容" },
            type: "writing_integrated"
          },
          {
            id: 5,
            order: 2,
            title: { en: "Lecture Content", tw: "講課內容", cn: "讲课内容" },
            type: "writing_integrated"
          },
          {
            id: 6,
            order: 3,
            title: { en: "Explanation", tw: "解釋", cn: "解释" },
            type: "writing_integrated"
          },
          {
            id: 7,
            order: 4,
            title: { en: "Language", tw: "語言", cn: "语言" },
            type: "writing_integrated"
          }
        ],
        writing_independent: [
          {
            id: 8,
            order: 1,
            title: {
              en: "Addresses the Topic",
              tw: "闡明主題",
              cn: "阐明主题"
            },
            type: "writing_independent"
          },
          {
            id: 9,
            order: 2,
            title: {
              en: "Addresses the Task",
              tw: "回應題目需求",
              cn: "回应题目需求"
            },
            type: "writing_independent"
          },
          {
            id: 10,
            order: 3,
            title: {
              en: "Details and Explanations",
              tw: "細節及解釋",
              cn: "细节及解释"
            },
            type: "writing_independent"
          },
          {
            id: 11,
            order: 4,
            title: {
              en: "Flow of Response",
              tw: "整體流暢度",
              cn: "整体流畅度"
            },
            type: "writing_independent"
          },
          {
            id: 12,
            order: 5,
            title: { en: "Language Usage", tw: "語言熟練度", cn: "语言熟练度" },
            type: "writing_independent"
          }
        ]
      },
      commentCategoriesSpeaking: {
        speaking_all: [
          {
            id: 1,
            order: 1,
            title: { en: "Delivery", tw: "表達", cn: "表达" },
            type: "speaking_all"
          },
          {
            id: 2,
            order: 2,
            title: { en: "Language Use", tw: "語言", cn: "语言" },
            type: "speaking_all"
          },
          {
            id: 3,
            order: 3,
            title: { en: "Topic Development", tw: "內容", cn: "内容" },
            type: "speaking_all"
          }
        ]
      },
      vipWriting: {
        exam_info: {
          exam_title: "Barron’s TOEFL Test 1 Writing: Task 1",
          exam_date: "2022-03-17",
          toefl_type: "App\\Entities\\ToeflChapter",
          student: {
            first_name: "EJ",
            last_name: "Lin",
            chinese_name: null,
            id: 49,
            email: "z8892463@gmail.com",
            photo_url: null,
            first_role: "student",
            all_roles: ["student", "pro"]
          },
          can_score: 1,
          can_suggest: 1,
          suggest_type: "detail",
          is_scored: 1,
          print_pdf: 0,
          is_finished: 1
        },
        list: [
          {
            user_exam_answer_id: 2179294,
            score: 4,
            suggest: "The question prompt asks you to use reasons to explain your answer. There may be reasons in this answer, but they are not clearly marked. Further, the connection between your ideas is not expressed clearly enough. For example, you say that you are “eager to attend to girls high school” because “excellent students study there.” However, you don’t explain why this is because “boys and girls attend separate schools.” Aren’t there excellent students at mixed schools, too?",
            answer_score_detail: {
              id: 27,
              user_exam_answer_id: 2179294,
              comment_type: "writing_integrated",
              overall_comment_url: "https://docs.google.com/document/d/1c-h8hEE87ttjm1bHlwRWqPC6Hho9JGwXIVpBw5ndhdU/edit",
              detail_score_comments: [
                {
                  id: 554,
                  answer_score_detail_id: 27,
                  comment_category_id: 4,
                  order: 1,
                  score: 4,
                  comment: "Although the task requires you to “agree or disagree,” you never state whether you agree or disagree. Instead, you seem to make an argument that the statement is true. Arguing in favor of a point-of-view is not the task you are asked to complete. Instead, you should explain why you agree or disagree with a statement",
                  comment_category: {
                    id: 4,
                    title: {
                      en: "Reading Content",
                      tw: "閱讀內容",
                      cn: "阅读内容"
                    },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 555,
                  answer_score_detail_id: 27,
                  comment_category_id: 5,
                  order: 2,
                  score: 2,
                  comment: "The question prompt asks you to use reasons to explain your answer. There may be reasons in this answer, but they are not clearly marked. Further, the connection between your ideas is not expressed clearly enough. For example, you say that you are “eager to attend to girls high school” because “excellent students study there.” However, you don’t explain why this is because “boys and girls attend separate schools.” Aren’t there excellent students at mixed schools, too?",
                  comment_category: {
                    id: 5,
                    title: {
                      en: "Lecture Content",
                      tw: "講課內容",
                      cn: "讲课内容"
                    },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 556,
                  answer_score_detail_id: 27,
                  comment_category_id: 6,
                  order: 3,
                  score: 3,
                  comment: "None of the things that “Winnie” did are unique to single-gender schools. Thus, your examples seem inappropriate and insufficient.",
                  comment_category: {
                    id: 6,
                    title: { en: "Explanation", tw: "解釋", cn: "解释" },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 557,
                  answer_score_detail_id: 27,
                  comment_category_id: 7,
                  order: 4,
                  score: 3,
                  comment: "There are multiple cases of word form errors. It would be useful for you to review some fundamental grammar principles. See my comments to the right of your essay. In addition, There are many sentence structure errors. You might want to work with a teacher to make certain that you understand correct sentence structure. See my comments to the right of your essay.",
                  comment_category: {
                    id: 7,
                    title: { en: "Language", tw: "語言", cn: "语言" },
                    type: "writing_integrated"
                  }
                }
              ]
            },
            is_correct: 1,
            taken_time: 3,
            order: 1,
            passage: 1,
            skill_name: "writing",
            exam_question_id: 59206,
            toefl_question_id: 9412,
            toefl_question_type: "integrated",
            correct_answer: [],
            user_answer: [
              "Some\tpeople\tmight\tthink\tthat\tattend\tseparate\tschools\tis\tgood\tfor\tstudents,\tothers\tconsider\tthat\t\nstudents\tshould\tattend\tschools\twithout\tdiverse\tof\tgenders.\tFor\tme,\tI\twas\teager\tto\tattend\tto\tgirls’\t\nhigh\tschool.\tBecause\texcellent\tstudents\toften\tchoose\tto\tstudy\tthere\tin\tthe\tTaiwan.\tTherefore,\t\nboys\tand\tgirls\tattending\tseparate\tschools\tbecause\tof\tmany\treason.\n\nFirst,\tstudents\twould\tbe\tmore\tconcentrated\ton\ttheir\tstudies.\tEveryone\tknow\thow\teasy\tto\t\ndistruct.\tAs\tmy\tsister\tWinnie,\tshe\tattended\tto\tTaipei\tFist\tGirls’\thigh\tschool\twhen\tshe\twas\t\nsixteen.\tIn\tthere,\tthey\toften\tstudied\tand\tplayed\ttogether\tall\tthe\ttime.\tDue\tthe\theavy\tworks,\tshe\t\nneed\tto\tstudy\tmore\tharder\tto\tget\thigher\tperformance.\tTherefore,\tstudying\tin\ta\tgirls’\thigh\tschool\t\nis\ta\tbest\tchose\tfor\ther.\tClassmates\twith\tsame\tages\tand\tgander\thelped\ther\tsolve\tmathematic\t\nproblems.\tGo\tto\tlibraries\ton\tweekends\tand\tattended\tto\tcram\tschools.\tSince\tthen,\tWinnie\twere\t\ninfluenced\tby\ther\tfriends\tthat\tshe\tworked\thardly\ton\tevery\tevent\tand\tfinally\tattended\tto\tTaiwan\t\nUniversity,\twhich\tthe\ttop\tone\tuniversity\tin\tthe\tTaiwan.\tAs\ta\tresult,\tstudying\twith\tsame\tgander\t\nschools\tdo\tactually\tmake\tstudents\twork\thardly.\n\nTo\tsum\tup,\tit\tis\tclear\tfor\twell\tdevelopment\tof\tstudents,\tseparate\tschool\tis\trequirement\tfor\t\nmorden\tsociety"
            ]
          }
        ]
      },
      simpleWriting: {
        exam_info: {
          exam_title: "TPO1 Writing: Education",
          exam_date: "2022-03-03",
          toefl_type: "App\\Entities\\ToeflChapter",
          student: {
            first_name: "EJ",
            last_name: "Lin",
            chinese_name: null,
            id: 49,
            email: "z8892463@gmail.com",
            photo_url: null,
            first_role: "student",
            all_roles: ["student", "pro"]
          },
          can_score: 1,
          can_suggest: 1,
          suggest_type: null,
          is_scored: 1,
          print_pdf: 0,
          is_finished: 1
        },
        list: [
          {
            user_exam_answer_id: 2179294,
            score: 4,
            suggest: "The question prompt asks you to use reasons to explain your answer. There may be reasons in this answer, but they are not clearly marked. Further, the connection between your ideas is not expressed clearly enough. For example, you say that you are “eager to attend to girls high school” because “excellent students study there.” However, you don’t explain why this is because “boys and girls attend separate schools.” Aren’t there excellent students at mixed schools, too?",
            answer_score_detail: {
              id: 27,
              user_exam_answer_id: 2179294,
              comment_type: "writing_integrated",
              overall_comment_url: "https://docs.google.com/document/d/1c-h8hEE87ttjm1bHlwRWqPC6Hho9JGwXIVpBw5ndhdU/edit",
              detail_score_comments: [
                {
                  id: 554,
                  answer_score_detail_id: 27,
                  comment_category_id: 4,
                  order: 1,
                  score: 4,
                  comment: "Although the task requires you to “agree or disagree,” you never state whether you agree or disagree. Instead, you seem to make an argument that the statement is true. Arguing in favor of a point-of-view is not the task you are asked to complete. Instead, you should explain why you agree or disagree with a statement",
                  comment_category: {
                    id: 4,
                    title: {
                      en: "Reading Content",
                      tw: "閱讀內容",
                      cn: "阅读内容"
                    },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 555,
                  answer_score_detail_id: 27,
                  comment_category_id: 5,
                  order: 2,
                  score: 2,
                  comment: "The question prompt asks you to use reasons to explain your answer. There may be reasons in this answer, but they are not clearly marked. Further, the connection between your ideas is not expressed clearly enough. For example, you say that you are “eager to attend to girls high school” because “excellent students study there.” However, you don’t explain why this is because “boys and girls attend separate schools.” Aren’t there excellent students at mixed schools, too?",
                  comment_category: {
                    id: 5,
                    title: {
                      en: "Lecture Content",
                      tw: "講課內容",
                      cn: "讲课内容"
                    },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 556,
                  answer_score_detail_id: 27,
                  comment_category_id: 6,
                  order: 3,
                  score: 3,
                  comment: "None of the things that “Winnie” did are unique to single-gender schools. Thus, your examples seem inappropriate and insufficient.",
                  comment_category: {
                    id: 6,
                    title: { en: "Explanation", tw: "解釋", cn: "解释" },
                    type: "writing_integrated"
                  }
                },
                {
                  id: 557,
                  answer_score_detail_id: 27,
                  comment_category_id: 7,
                  order: 4,
                  score: 3,
                  comment: "There are multiple cases of word form errors. It would be useful for you to review some fundamental grammar principles. See my comments to the right of your essay. In addition, There are many sentence structure errors. You might want to work with a teacher to make certain that you understand correct sentence structure. See my comments to the right of your essay.",
                  comment_category: {
                    id: 7,
                    title: { en: "Language", tw: "語言", cn: "语言" },
                    type: "writing_integrated"
                  }
                }
              ]
            },
            is_correct: 1,
            taken_time: 3,
            order: 1,
            passage: 1,
            skill_name: "writing",
            exam_question_id: 59206,
            toefl_question_id: 9412,
            toefl_question_type: "integrated",
            correct_answer: [],
            user_answer: [
              "Some\tpeople\tmight\tthink\tthat\tattend\tseparate\tschools\tis\tgood\tfor\tstudents,\tothers\tconsider\tthat\t\nstudents\tshould\tattend\tschools\twithout\tdiverse\tof\tgenders.\tFor\tme,\tI\twas\teager\tto\tattend\tto\tgirls’\t\nhigh\tschool.\tBecause\texcellent\tstudents\toften\tchoose\tto\tstudy\tthere\tin\tthe\tTaiwan.\tTherefore,\t\nboys\tand\tgirls\tattending\tseparate\tschools\tbecause\tof\tmany\treason.\n\nFirst,\tstudents\twould\tbe\tmore\tconcentrated\ton\ttheir\tstudies.\tEveryone\tknow\thow\teasy\tto\t\ndistruct.\tAs\tmy\tsister\tWinnie,\tshe\tattended\tto\tTaipei\tFist\tGirls’\thigh\tschool\twhen\tshe\twas\t\nsixteen.\tIn\tthere,\tthey\toften\tstudied\tand\tplayed\ttogether\tall\tthe\ttime.\tDue\tthe\theavy\tworks,\tshe\t\nneed\tto\tstudy\tmore\tharder\tto\tget\thigher\tperformance.\tTherefore,\tstudying\tin\ta\tgirls’\thigh\tschool\t\nis\ta\tbest\tchose\tfor\ther.\tClassmates\twith\tsame\tages\tand\tgander\thelped\ther\tsolve\tmathematic\t\nproblems.\tGo\tto\tlibraries\ton\tweekends\tand\tattended\tto\tcram\tschools.\tSince\tthen,\tWinnie\twere\t\ninfluenced\tby\ther\tfriends\tthat\tshe\tworked\thardly\ton\tevery\tevent\tand\tfinally\tattended\tto\tTaiwan\t\nUniversity,\twhich\tthe\ttop\tone\tuniversity\tin\tthe\tTaiwan.\tAs\ta\tresult,\tstudying\twith\tsame\tgander\t\nschools\tdo\tactually\tmake\tstudents\twork\thardly.\n\nTo\tsum\tup,\tit\tis\tclear\tfor\twell\tdevelopment\tof\tstudents,\tseparate\tschool\tis\trequirement\tfor\t\nmorden\tsociety"
            ]
          }
        ]
      },
      simpleSpeaking: {
        exam_info: {
          exam_title: "TPO24 Speaking",
          exam_date: "2022-02-25",
          toefl_type: "App\\Entities\\ToeflSingleSection",
          student: {
            first_name: "Sheraz",
            last_name: "herzalla",
            chinese_name: null,
            id: 1122,
            email: "Sherzalla93@gmail.com",
            photo_url: null,
            first_role: "student",
            all_roles: ["student", "vip1", "pro", "old-pro"]
          },
          can_score: 1,
          can_suggest: 1,
          suggest_type: "outline",
          is_scored: 1,
          print_pdf: 0,
          is_finished: 1
        },
        list: [
          {
            user_exam_answer_id: 2177298,
            score: 1,
            suggest: "This is a generally strong answer in all areas. However there are some minor difficulties with certain words and phrases. Prepositions are often misused, but this does not significantly impact the listeners ability to understand.",
            answer_score_detail: {
              id: 2,
              user_exam_answer_id: 2177298,
              comment_type: "speaking_all",
              overall_comment_url: null,
              detail_score_comments: [
                {
                  id: 64,
                  answer_score_detail_id: 2,
                  comment_category_id: 1,
                  order: 1,
                  score: 1,
                  comment: "This was a strong answer with good pronunciation and pace. The information was accurate, though there were some minor problems with grammar.",
                  comment_category: {
                    id: 1,
                    title: { en: "Delivery", tw: "表達", cn: "表达" },
                    type: "speaking_all"
                  }
                },
                {
                  id: 65,
                  answer_score_detail_id: 2,
                  comment_category_id: 2,
                  order: 2,
                  score: 3,
                  comment: "This was a generally strong answer with minor grammar issues that result in a lack of clarity in some places.",
                  comment_category: {
                    id: 2,
                    title: { en: "Language Use", tw: "語言", cn: "语言" },
                    type: "speaking_all"
                  }
                },
                {
                  id: 66,
                  answer_score_detail_id: 2,
                  comment_category_id: 3,
                  order: 3,
                  score: 5,
                  comment: "This answer is OK, but it was somewhat incomplete and also seemed more like a summary than an explanation.",
                  comment_category: {
                    id: 3,
                    title: { en: "Topic Development", tw: "內容", cn: "内容" },
                    type: "speaking_all"
                  }
                }
              ]
            },
            is_correct: 1,
            taken_time: 0,
            order: 1,
            passage: 2,
            skill_name: "speaking",
            exam_question_id: 23275,
            toefl_question_id: 7614,
            toefl_question_type: "article_audio",
            correct_answer: [],
            user_answer: [
              "https://ivy-way-toefl.s3.ap-northeast-1.amazonaws.com/documents/toefl_listening/2022-02-25_6217d81a53324_record.wav"
            ],
            canPlay: true,
            width: 0,
            progress: 0,
            time: 59.904,
            speed: 1
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {
    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    }
  },
  methods: {
    getResolve(question_id) {
      // const { href } = this.$router.resolve({
      //   name: "ToeflResolve",
      //   query: {
      //     user_exam_id: this.user_exam_id,
      //     question_id: question_id
      //   }
      // });
      // return href;
    }
  }
};
</script>

<style scoped>
.container {
  padding-top: 40px;
}
::v-deep .el-tabs__item {
  position: relative;
}

.tabLink {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

::v-deep .el-alert--info {
  background-color: rgb(225, 240, 247);
}
b,
strong {
  font-weight: 500 !important;
}
.card >>> .el-form .el-form-item {
  margin-bottom: 0;
}
.report {
  margin: 20px auto 40px;
  border: 1px solid #ccc;
}
.report-title {
  height: 80px;
  background: var(--themeColor);
  padding: 20px 32px;
}
.title-cont .title {
  font-size: 24px;
  line-height: 40px;
  font-weight: 700;
  float: left;
  margin-right: 12px;
  color: white;
}
.datas-title {
  margin: 16px 0;
  overflow: hidden;
}
.report-body {
  padding: 20px 32px;
}
.card {
  padding: 20px;
}
.section {
  margin: 10px 0;
}
</style>
